<!--
  --
  -- 個人情報設定 ページ
  --
  -->
<template>
  <c-container form v-if="profile">
    <c-profile-group
      :profile="profile"
      @submit="onSubmit"
    >
      <!-- タイトル -->
      <template #title>会員情報を変更</template>

      <!-- 説明文 -->
      <template>
        <p>
          会員情報を入力して下さい。
        </p>
      </template>

      <template #submit-text>変更</template>
    </c-profile-group>
  </c-container>
</template>

<script>
import page from '@/mixins/page'
import CProfileGroup from '@/pages/register/Profile/CProfileGroup'

import * as api from '@/api'
import { run } from '@/libs/a'

export default {
  name: 'Profile',
  mixins: [
    page('会員情報を設定')
  ],
  components: {
    CProfileGroup
  },

  /**
   * データ取得
   */
  async prepare (to, from, store) {
    // ログイン中のユーザID を取得する
    const userID = store.getters['user/id']
    if (!userID) {
      throw new Error('The user is not logged in.')
    }

    // 個人情報を取得する
    const resp = await api.getUserProfile(userID)

    return {
      userID: resp.data.id,
      profile: resp.data.profile
    }
  },

  props: {
    userID: Number,
    profile: Object
  },

  methods: {
    /**
     * フォームが入力された
     */
    onSubmit (form) {
      run(async () => {
        await api.putUserProfile(this.userID, {
          profile: form
        })

        this.back()
      })
    }
  }
}
</script>
